import { render } from "./rewardPoints.vue?vue&type=template&id=3cbbea4e&scoped=true"
import script from "./rewardPoints.vue?vue&type=script&lang=js"
export * from "./rewardPoints.vue?vue&type=script&lang=js"

import "./rewardPoints.vue?vue&type=style&index=0&id=3cbbea4e&lang=scss&scoped=true"
import "./rewardPoints.vue?vue&type=style&index=1&id=3cbbea4e&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbbea4e"]])

export default __exports__